import { inject, Injectable } from '@angular/core';
import { Apollo, gql } from 'apollo-angular';
import { DocumentNode } from 'graphql';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { RoleService } from '../role/role.service';
import { FeatureDto, GetFeaturesResponse } from './feature.interface';

const GET_FEATURES: DocumentNode = gql`
  query GetFeatures($first: Int, $after: String, $accessLevel: DataAccessLevel) {
    GetFeatures(first: $first, after: $after, accessLevel: $accessLevel) {
      nodes {
        id
        name
        description
        createdOnUtc
        modifiedOnUtc
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;

/** Service for retrieving feature data via GraphQL API. */
@Injectable()
export class FeatureService {
  /** Apollo client for GraphQL queries. */
  private readonly apollo: Apollo = inject(Apollo);

  /** Role service for determining data access level. */
  private readonly roleService: RoleService = inject(RoleService);

  /**
   * Gets all available features.
   * @returns Observable<Array<FeatureDto>> - Array of feature data from API
   */
  public getFeatures(): Observable<Array<FeatureDto>> {
    return this.apollo
      .query<GetFeaturesResponse>({
        query: GET_FEATURES,
        variables: { accessLevel: this.roleService.getAccessLevel() },
        fetchPolicy: 'network-only'
      })
      .pipe(map((result): Array<FeatureDto> => result.data?.GetFeatures?.nodes ?? []));
  }
}
